import type { CategoryListItemDto } from '@/queries/categories/categories.schema';
import { useTranslations } from 'next-intl';
import { Icon } from '@/components/entities/Sprite/Icon';
import CategoryItem from '@/components/features/layout/Navigation/components/Sidebar/components/SidebarContent/components/NavigationItems/components/CategoryItem';
import { CustomAccordion } from '@/components/ui/Accordion/CustomAccordion';

interface OtherCategoriesAccordionProps {
  handleCloseSideBar: () => void;
  isMenuMinify: boolean;
  categoryId: string;
  otherCategories: CategoryListItemDto[];
}

const OtherCategoriesAccordion = ({
  handleCloseSideBar,
  isMenuMinify,
  categoryId,
  otherCategories,
}: OtherCategoriesAccordionProps) => {
  const t = useTranslations('side-menu');

  return (
    <div className="rounded-none -mx-2.5 mt-1">
      <CustomAccordion
        triggerClassName='group relative bg-transparent py-2.5 pl-3.5 3xl:py-3.5 lg:pl-[0.85rem] pr-[0.6875rem] items-center justify-start justify-between rounded-[3.125rem]
                before:content-[""] before:absolute before:inset-0 before:rounded-[3.125rem]
                before:bg-header-gradient before:opacity-0 before:transition-opacity before:duration-200 before:pointer-events-none
                hover:before:opacity-100 mx-2'
        contentRootClassName="3xl:-mr-4.5 3xl:-ml-[1.063rem]"
        contentClassName="bg-black-main-900 p-0 mt-2.5 lg:mt-0.5"
        iconClosed={<Icon name="arrow-top" className="size-4 shrink-0 text-violet-c200 rotate-180 transition-transform duration-500" />}
        iconOpened={<Icon name="arrow-top" className="size-4 shrink-0 text-violet-c200 rotate-0 transition-transform duration-500" />}
        items={[
          {
            value: 'other-categories',
            trigger: (
              <div className="flex items-center gap-2 text-c100 paragraph-s-medium 3xl:paragraph-m-regular">
                <Icon name="other-category" className="relative hover:opacity-100 size-6 shrink-0 text-c100 ml-auto" />
                <span className="relative before:opacity-100 paragraph-s-medium 3xl:paragraph-m-regular">{t('more-categories')}</span>
              </div>
            ),
            content: (
              <div className="flex flex-col gap-1 lg:gap-1 pb-2 px-2.5 pt-0.75 relative">
                <div className="absolute top-0 left-0 w-full h-full bg-header-gradient opacity-50" />
                {otherCategories.map(category => (
                  <CategoryItem
                    key={category.id}
                    category={category}
                    categoryId={categoryId}
                    handleCloseSideBar={handleCloseSideBar}
                    isMenuMinify={isMenuMinify}
                    className="3xl:mx-5"
                  />
                ))}
              </div>
            ),
          },
        ]}
        collapsible
      />
    </div>
  );
};

export default OtherCategoriesAccordion;
